module.exports = __webpack_public_path__ + "img/0a465117154b4cd38b465bd5159000b6.48386cf9.jpg";